import { createContext, useContext, useState } from 'react'
import { rrhhService } from '../services/rrhhService'
import { useUtiles } from './utilesContext'
import { useNavigate } from 'react-router'
import * as XLSX from 'xlsx'
const RrhhContext = createContext()

export const useRrhh = () => {
    return useContext(RrhhContext)
}

export const RrhhProvider = ({ children }) => {

    const { setAlertSnackbar } = useUtiles()

    const navigate = useNavigate()

    const [rrhh, setRrhh] = useState([])
    const [personal, setPersonal] = useState({
        num_document: '',
        fullName: '',
        email: '',
        position: '',
        phone: '',
        is_active: true,
        location: null
    })
    const [loadingRrhh, setLoadingRrhh] = useState(false)
    const [pagination, setPagination] = useState({})
 
    const resetPersonal = () => {
        setPersonal({
            num_document: '',
            fullName: '',
            email: '',
            position: '',
            phone: '',
            is_active: true,
            location: null
        })
    }


    const selectLocation = (location) => {
        setPersonal({ ...personal, location: location })
    }

    /**
     * OBTENER TODO RRHH
     */
    const getRrhh = async (filters) => {
        try {
            setLoadingRrhh(true)
            const response = await rrhhService.getRrhh(filters)
            setRrhh(response.data.users)
            console.log(response.data.users)
            setPagination(response.data.pagination)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingRrhh(false)
        }
    }

    /**
     * OBTENER RRHH POR HASH_CODE
     */

    const getRrhhByHashCode = async (hashCode) => {
        try {
            const response = await rrhhService.getRrhhByHashCode(hashCode)
            setPersonal(response.data)
            console.log(response.data)
            setAlertSnackbar({
                open: true,
                message: 'Personal obtenido correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: 'Error al obtener el personal',
                severity: 'error'
            })
        }
    }

    /**
     * CREAR RRHH
     */
    const [loadingCreateRrhh, setLoadingCreateRrhh] = useState(false)
    const createRrhh = async () => {
        try {
            setLoadingCreateRrhh(true)
            const dataToSend = {
                ...personal,
                location: personal.location ? personal.location.code : null
            }
            const response = await rrhhService.postRrhh(dataToSend)
            await getRrhh()
            setAlertSnackbar({
                open: true,
                message: 'Personal creado correctamente',
                severity: 'success'
            })
            resetPersonal()
            navigate('/rrhh')
        } catch (error) {
            console.log(error)  
            setAlertSnackbar({
                open: true,
                message: 'Error al crear el personal',
                severity: 'error'
            })
        } finally {
            setLoadingCreateRrhh(false)
        }
    }


    /**
     * UPDATE RRHH
     */
    const [loadingUpdateRrhh, setLoadingUpdateRrhh] = useState(false)
    const updateRrhh = async () => {
        try {
            setLoadingUpdateRrhh(true)
            const dataToSend = {
                ...personal,
                location: personal.location ? personal.location.code : null
            }
            const response = await rrhhService.putRrhh(dataToSend)
            setAlertSnackbar({
                open: true,
                message: 'Personal actualizado correctamente',
                severity: 'success'
            })
            resetPersonal()
            navigate('/rrhh')
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: 'Error al actualizar el personal',
                severity: 'error'
            })
        } finally {
            setLoadingUpdateRrhh(false)
        }
    }

    /**
     * CARGAR RRHH MASIVO
     */
    const [loadingUploadMasive, setLoadingUploadMasive] = useState(false)
    const [dataMasive, setDataMasive] = useState(null)
    const [responseMasive, setResponseMasive] = useState(null)
    const loadMasiveRrhh = async (files) => {
        try{
            setLoadingUploadMasive(true)    
            const file = files[0]
            const reader = new FileReader()

            reader.onload = (event) => {
                const arrayBuffer = event.target.result;
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);
                
                // Procesa los datos aquí
                console.log(data)
                setDataMasive(data)

              };
              
              reader.readAsArrayBuffer(file);
        }catch(error){
            console.log(error)
        }finally{   
            setLoadingUploadMasive(false)
        }
    }

    /**
     * PROCESAR RRHH MASIVO
     */
    const [loadingMasive, setLoadingMasive] = useState(false)
    const processMasiveRrhh = async () => {
        setLoadingMasive(true)
        try{
            
            const response = await rrhhService.postMasiveRrhh(dataMasive)
            setResponseMasive(response.data)
            console.log(response.data)
            setDataMasive(null)
            await getRrhh()


            setAlertSnackbar({
                open: true,
                message: "Personal procesado correctamente",
                severity: 'success'
            })

            setDataMasive(null)
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al procesar el personal",
                severity: 'error'
            })
        }finally{
            setLoadingMasive(false)
        }
    }


    /**
     * OBTENER RRHH POR NOMBRE
     */
    const [loadingGetRrhhByName, setLoadingGetRrhhByName] = useState(false)
    const [rrhhByName, setRrhhByName] = useState([])
    const getRrhhByName = async (params) => {
        try{
            setLoadingGetRrhhByName(true)
            const response = await rrhhService.getRrhhByName(params)
            setRrhhByName(response.data)
        }catch(error){
            console.log(error)
        }finally{
            setLoadingGetRrhhByName(false)
        }
    }

    return <RrhhContext.Provider value={{ 
        rrhh,
        personal, 
        setPersonal,
        loadingRrhh, 
        resetPersonal, 
        getRrhh,
        getRrhhByHashCode,
        createRrhh,
        loadingCreateRrhh,
        pagination,
        setPagination,
        loadingUploadMasive,
        dataMasive,
        setDataMasive,
        responseMasive,
        setResponseMasive,
        loadMasiveRrhh,
        processMasiveRrhh,
        selectLocation,
        loadingMasive,
        updateRrhh,
        loadingUpdateRrhh,
        getRrhhByName,
        loadingGetRrhhByName,
        rrhhByName
    }}>{children}</RrhhContext.Provider>
}